export enum AppRoutes {
    Login = '/login',

    Details = '/details',
    ConfirmUpdate = '/details/confirm-update',
    
    Signup = '/signup/',
    PhoneEnter = '/signup/phone',
    PhoneConfirm = '/signup/phone/confirm',

    ResetPassword = '/password',
    EnterPhone= '/password/phone',
    VerifyCode = '/password/verify',
    NewPassword = '/password/reset'
}